import React from "react";
import PropTypes from "prop-types";

const DAY = 24 * 60;

const ReleaseOffsetField = ({ id, value, onChange }) => {
  const days = value != null && value % DAY === 0;
  const [unit, setUnit] = React.useState(days ? "days" : "hours");
  const amount = value == null ? "" : String(value / (unit === "days" ? DAY : 60));
  const emit = (nextAmount, nextUnit) => {
    const number = Math.round(Number(nextAmount));
    onChange(nextAmount === "" || !(number > 0) ? null : number * (nextUnit === "days" ? DAY : 60));
  };

  return (
    <div>
      <label className="series-edit-label" htmlFor={id}>
        Release before show
      </label>
      <div className="series-release-offset">
        <input
          id={id}
          type="number"
          min="1"
          className="series-edit-input"
          placeholder="Never"
          value={amount}
          onChange={(event) => emit(event.target.value, unit)}
        />
        <select
          className="series-edit-input"
          aria-label="Release unit"
          value={unit}
          onChange={(event) => {
            setUnit(event.target.value);
            emit(amount, event.target.value);
          }}
        >
          <option value="hours">hours</option>
          <option value="days">days</option>
        </select>
      </div>
      <p className="series-edit-hint">Leave blank to keep the hold until you release it.</p>
    </div>
  );
};

ReleaseOffsetField.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export const releaseOffsetLabel = (minutes) => {
  if (minutes == null) return "Never";
  if (minutes % DAY === 0) return `${minutes / DAY} ${minutes === DAY ? "day" : "days"} before`;
  return `${minutes / 60} ${minutes === 60 ? "hour" : "hours"} before`;
};

export default ReleaseOffsetField;
